import React from 'react';

const FishIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M6.5 12c.94 4.56 3.53 9 7.61 9 4.08 0 6.67-4.44 7.61-9a6.72 6.72 0 0 0-7.61-7c-4.08 0-6.67 4.44-7.61 7Z" />
    <path d="M2 12c1.4 0 2.5 1.1 2.5 2.5s1.1 2.5 2.5 2.5 2.5-1.1 2.5-2.5-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5" />
    <path d="M18 12c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2Z" />
    <path d="M16 8l-4 4 4 4" />
  </svg>
);

export default FishIcon;